/**
 * ⛔ LA PANTALLA Y EL TOKEN TIENEN QUE SER LA MISMA CUENTA. (Joel Pérez, 24/09/2026)
 *
 * La cookie de renovación es UNA por navegador. Con dos cuentas en el mismo navegador
 * (Joel y "Admin Shark"), una pestaña renovaba la sesión y recibía el token de la OTRA
 * cuenta; como la renovación solo cambia el token, la pantalla seguía diciendo "Admin
 * Shark" mientras el backend respondía como Joel. El Reporte comercial le mostró su propia
 * cartera (28) como si fuera la de la oficina (209) y reportó "números erróneos".
 */

/** El `sub` (id del usuario) de un JWT, sin verificarlo: solo para comparar cuentas. */
export function subDelToken(token: string | null | undefined): string | null {
  const payload = token?.split('.')[1];
  if (!payload) return null;
  try {
    const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return typeof json.sub === 'string' ? json.sub : null;
  } catch { return null; }
}

/** ¿El token renovado es de otra cuenta que la que muestra la pantalla? */
export function esOtraCuenta(tokenNuevo: string, idMostrado: string | null | undefined): boolean {
  const sub = subDelToken(tokenNuevo);
  return !!sub && !!idMostrado && sub !== idMostrado;
}
